export default function ($translate) {
    return {
        KEYS: {
            SPECIFIC: 'SPECIFIC',
            SIMPLE: 'SIMPLE'
        },
        LABELS: {
            SPECIFIC: $translate.instant('course.external.participation.Specific'),
            SIMPLE: $translate.instant('course.external.participation.Simple')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/externalParticipationRequestType/index.js